import { Button } from '@warp-ds/react';
import { useState } from 'react';
import { trackCreateOrRepublishAdButton } from '@/utils/tracking';

interface RepublishFormButtonProps {
    actionPath: string;
    csrfMicroServiceToken: string;
    itemId: string | undefined;
}

export const RepublishFormButton = ({ actionPath, csrfMicroServiceToken, itemId }: RepublishFormButtonProps) => {
    const [loading, setLoading] = useState(false);

    return (
        <form action={actionPath} method="GET">
            <input type="hidden" name="adType" value="realestate-letting" />
            <input type="hidden" name="__csrf_token" value={csrfMicroServiceToken} />
            <Button
                onClick={() => {
                    setLoading(true);
                    trackCreateOrRepublishAdButton('finn', itemId, true);
                    setTimeout(() => {
                        setLoading(false);
                    }, 10000);
                }}
                data-post-button
                loading={loading}
                fullWidth
                type="submit">
                Republiser annonse på FINN
            </Button>
        </form>
    );
};
